import React from 'react';

const CropCard = ({ crop }) => {
  return (
    <div className="w-full md:w-1/2 md:pl-4 mb-5">
      <div className="h-76 bg-white rounded px-6 py-10">
        <h1 className="text-4xl font-bold mb-3">Crop Info</h1>
        <ul>
          <li className="py-1">
            <div className="w-1/3 px-2">
              <img
                src={crop.imageUrl}
                alt={crop.name}
                className="inline-block h-full w-full object-cover"
              />
            </div>
          </li>
          <li className="py-1">
            Name - <span className="text-sm">{crop.name} month(s)</span>
          </li>
          <li className="py-1">
            Description - <span className="text-sm">{crop.description}</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default CropCard;
